import { useRouterState } from '@tanstack/react-router';

/** The five sections, in sidebar order. The key is also the keyboard shortcut; the tone is its line colour. */
export const SECTIONS = [
  { to: '/oggi', label: 'Oggi', key: '1', tone: 'oggi' },
  { to: '/attivita', label: 'Attività', key: '2', tone: 'attivita' },
  { to: '/finanze', label: 'Finanze', key: '3', tone: 'finanze' },
  { to: '/calendario', label: 'Calendario', key: '4', tone: 'calendario' },
  { to: '/focus', label: 'Focus', key: '5', tone: 'focus' },
  { to: '/incassi', label: 'Incassi', key: '6', tone: 'incassi' },
] as const;

export type Section = (typeof SECTIONS)[number];
export type Tone = Section['tone'];

/** The section the current page belongs to, or null outside them (settings). */
export function useCurrentSection(): Section | null {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  return (
    SECTIONS.find((section) => pathname === section.to || pathname.startsWith(`${section.to}/`)) ??
    null
  );
}
